import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import warn from 'rc-util/lib/warning';
import { updateCSS } from 'rc-util/lib/Dom/dynamicCSS';
export function warning(valid, message) {
  warn(valid, "[@d-design/icons] " + message);
}
export function isIconDefinition(target) {
  return typeof target === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (typeof target.icon === 'object' || typeof target.icon === 'function');
}
export function normalizeAttrs(attrs) {
  if (attrs === void 0) {
    attrs = {};
  }
  return Object.keys(attrs).reduce(function (acc, key) {
    var val = attrs[key];
    switch (key) {
      case 'class':
        acc.className = val;
        delete acc["class"];
        break;
      default:
        acc[key] = val;
    }
    return acc;
  }, {});
}
export function generate(node, key, rootProps) {
  if (!rootProps) {
    return /*#__PURE__*/React.createElement(node.tag, _extends({
      key: key
    }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
      return generate(child, key + "-" + node.tag + "-" + index);
    }));
  }
  return /*#__PURE__*/React.createElement(node.tag, _extends({
    key: key
  }, normalizeAttrs(node.attrs), rootProps), (node.children || []).map(function (child, index) {
    return generate(child, key + "-" + node.tag + "-" + index);
  }));
}
export function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }
  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
}

// These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
export var svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor',
  'aria-hidden': 'true',
  focusable: 'false'
};
export var iconStyles = "\n.dd-icon-btn {\n  padding: 4px;\n  display: inline-block;\n  border-radius: 4px;\n  color: var(--common_level1_base_color, rgba(23,26,29,1));\n}\n\n.dd-icon-btn:hover {\n  background-color: var(--common_overlay_hover_color, rgba(0, 0, 0, 0.08));\n}\n\n.dd-icon-btn:active {\n  background-color: var(--common_overlay_press_color, rgba(0, 0, 0, 0.16));\n}\n\n.dd-icon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.dd-icon > * {\n  line-height: 1;\n}\n.dd-icon svg {\n  display: inline-block;\n}\n.dd-icon::before {\n  display: none;\n}\n\n.dd-icon-spin::before,\n.dd-icon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
export var useInsertStyles = function useInsertStyles(styleStr) {
  if (styleStr === void 0) {
    styleStr = iconStyles;
  }
  useEffect(function () {
    updateCSS(styleStr, 'dd-icons', {
      prepend: true
    });
  }, []);
};